const ReactCustomEvents = {
  sendNotification: 'send-notification',
  openDialog: 'open-dialog',
  maintenanceMode: 'maintenance-mode',
  autoCompleteField: 'Field/AutoComplete-',
};

export default ReactCustomEvents;
